/**
 * Built-in, hand-authored Persian (Farsi) catalogue for the ENTIRE system.
 *
 * These are quality translations baked into the app — no machine translation
 * needed. They activate automatically whenever Persian is the active language:
 *   • customer menu UI       → tu()  falls back here before English
 *   • restaurant admin panel → ta()  falls back here before English
 * A restaurant's own saved translations always take priority, so admins can
 * still fine-tune any string; this catalogue is the default underneath.
 *
 * (The platform dashboards/login pages already have a full hand-authored
 * Persian catalogue in src/lang/strings.js — STRINGS.persian.)
 */

// ── Customer-facing menu / cart / auth / platform-home UI ─────────────────────
export const UI_FA = {
  nav_menu: 'منو',
  nav_cart: 'سبد خرید',
  nav_back: 'بازگشت',
  otp_phone_label: 'شماره موبایل',
  otp_send_btn: 'ارسال کد',
  otp_code_label: 'کد تأیید',
  otp_verify_btn: 'تأیید و ادامه',
  otp_name_label: 'نام شما (اختیاری)',
  otp_name_ph: 'مثلاً سارا',
  otp_change_phone: 'تغییر شماره',
  otp_resend: 'ارسال مجدد کد',
  otp_sent_to: 'کد به این شماره ارسال شد',
  landing_view_menu: 'مشاهده منو ←',
  landing_enter_menu: 'ورود به منو',
  landing_maps: 'باز کردن در نقشه گوگل ↗',
  landing_location: 'موقعیت',
  landing_phone: 'تلفن',
  landing_hours: 'ساعت کاری',
  landing_email: 'ایمیل',
  menu_search: 'جستجوی غذاها…',
  menu_all: 'همه',
  menu_items: 'آیتم',
  menu_no_items: 'موردی یافت نشد',
  menu_show_original: 'نمایش نام اصلی',
  menu_original_name: 'اصلی',
  menu_results_for: 'نتایج برای',
  menu_in_cart: 'در سبد خرید',
  menu_only_at: 'فقط در',
  menu_all_branches: 'همهٔ شعبه‌ها',
  menu_pick_branch: 'برای ثبت سفارش یک شعبه انتخاب کنید',
  menu_add: '+ افزودن',
  menu_unavailable: 'ناموجود',
  menu_view_cart: 'مشاهده سبد خرید ←',
  menu_related: 'شاید بپسندید',
  menu_powered_by: 'قدرت‌گرفته از',
  menu_share: 'اشتراک‌گذاری',
  share_whatsapp: 'واتساپ',
  share_telegram: 'تلگرام',
  share_copy: 'کپی لینک',
  share_copied: 'لینک کپی شد ✓',
  fav_add: 'افزودن به علاقه‌مندی‌ها',
  fav_remove: 'حذف از علاقه‌مندی‌ها',
  profile_favs_tab: 'علاقه‌مندی‌ها',
  profile_no_favs: 'هنوز موردی ندارید — روی ♥ هر غذا بزنید.',
  track_title: 'پیگیری سفارش',
  track_order_no: 'سفارش',
  track_status: 'وضعیت',
  track_items: 'اقلام',
  track_total: 'جمع کل',
  track_placed_at: 'زمان ثبت',
  track_auto: 'به‌صورت خودکار به‌روزرسانی می‌شود',
  track_not_found: 'سفارش یافت نشد',
  track_cta: 'پیگیری سفارش ←',
  cart_title: 'سبد خرید شما',
  cart_clear: 'پاک کردن همه',
  cart_empty: 'سبد خرید شما خالی است',
  cart_browse: 'مشاهده منو',
  cart_summary: 'خلاصه سفارش',
  cart_subtotal: 'جمع جزء',
  cart_service_fee: 'هزینه خدمات (۵٪)',
  cart_total: 'جمع کل',
  cart_place_order: 'ثبت سفارش',
  cart_back: '← منو',
  confirm_title: 'سفارش خود را تأیید کنید',
  confirm_name: 'نام',
  confirm_phone: 'تلفن',
  confirm_address: 'آدرس',
  confirm_note: 'سفارش شما به آدرس بالا تحویل داده می‌شود. همه‌چیز درست است؟',
  confirm_edit: 'ویرایش اطلاعات',
  confirm_yes: 'بله، ثبت سفارش ✓',
  success_title: 'سفارش ثبت شد!',
  success_msg: 'سفارش شما دریافت شد',
  success_delivering: 'تحویل به',
  success_contact: 'تماس',
  success_continue: 'ادامه سفارش',
  success_home: 'بازگشت به خانه',
  auth_signin_title: 'برای ثبت سفارش وارد شوید',
  auth_signin_sub: 'برای پیگیری سفارش‌ها و ذخیره اطلاعات تحویل، به حساب کاربری نیاز دارید.',
  auth_signin: 'ورود',
  auth_register: 'ثبت‌نام',
  auth_name: 'نام و نام خانوادگی',
  auth_email: 'ایمیل',
  auth_password: 'رمز عبور',
  auth_phone: 'شماره تلفن',
  auth_address: 'آدرس تحویل',
  auth_create: 'ایجاد حساب',
  profile_tab: 'پروفایل',
  profile_orders_tab: 'سفارش‌های من',
  profile_save: 'ذخیره تغییرات',
  profile_logout: 'خروج',
  profile_no_orders: 'هنوز سفارشی ندارید.',
  profile_browse: 'مشاهده منو ←',
  profile_phone: 'تلفن',
  profile_address: 'آدرس تحویل',
  profile_curr_pass: 'رمز عبور فعلی',
  profile_new_pass: 'رمز عبور جدید',
  cp_title: 'پروفایل خود را تکمیل کنید',
  cp_sub: 'پیش از ثبت سفارش به شماره تلفن و آدرس شما نیاز داریم.',
  cp_save: 'ذخیره و ادامه',
  status_pending: 'در انتظار',
  status_confirmed: 'تأیید شده',
  status_preparing: 'در حال آماده‌سازی',
  status_ready: 'آماده',
  status_delivered: 'تحویل شده',
  status_cancelled: 'لغو شده',
  pl_nav_features: 'امکانات',
  pl_nav_demos: 'نمونه‌های زنده',
  pl_nav_pricing: 'تعرفه‌ها',
  pl_nav_signin: 'ورود',
  pl_nav_get_started: 'شروع رایگان',
  pl_hero_badge: 'پلتفرم همه‌کاره منوی دیجیتال',
  pl_hero_title: 'رستوران شما شایسته یک منوی دیجیتال زیباست',
  pl_hero_sub: 'در چند دقیقه یک منوی چشم‌نواز روی زیردامنه اختصاصی‌تان راه‌اندازی کنید. مدیریت محصولات، دریافت سفارش و رشد — همه از یک داشبورد.',
  pl_hero_cta: 'شروع رایگان',
  pl_hero_cta2: 'مشاهده نمونه‌های زنده',
  pl_stat_live: 'رستوران فعال',
  pl_stat_mobile: 'موبایل‌محور',
  pl_stat_setup: 'زمان راه‌اندازی',
  pl_demos_tag: 'نمونه‌های زنده',
  pl_demos_title: 'در عمل ببینید',
  pl_demos_sub: 'این رستوران‌ها همین حالا با نوشین کار می‌کنند. برای دیدن منویشان کلیک کنید.',
  pl_feat_tag: 'چرا نوشین',
  pl_feat_title: 'هر آنچه رستوران شما نیاز دارد',
  pl_feat_1_t: 'منوی فوری روی زیردامنه',
  pl_feat_1_d: 'آدرس اختصاصی شما در چند دقیقه فعال می‌شود؛ منویی زیبا و موبایل‌محور که مشتریان دوست دارند.',
  pl_feat_2_t: 'کد QR آماده',
  pl_feat_2_d: 'کد QR بسازید تا مهمانان مستقیم به منوی دیجیتال شما برسند. بدون نیاز به نصب اپلیکیشن.',
  pl_feat_3_t: 'سفارش‌های لحظه‌ای',
  pl_feat_3_d: 'سفارش‌ها را همان لحظه دریافت و مدیریت کنید؛ وضعیت را از «در انتظار» تا «تحویل شده» به‌روز کنید.',
  pl_feat_4_t: 'ویرایشگر زنده منو',
  pl_feat_4_d: 'هر آیتم را فوراً از پنل مدیریت اضافه یا ویرایش کنید. تغییرات در چند ثانیه اعمال می‌شود.',
  pl_feat_5_t: 'داشبورد تحلیل',
  pl_feat_5_d: 'سفارش‌ها، درآمد و رفتار مشتری را با داشبورد تحلیل و هوش مصنوعی دنبال کنید.',
  pl_feat_6_t: 'احراز هویت سه‌لایه',
  pl_feat_6_d: 'ورود جداگانه برای مشتریان، مدیران رستوران و مالکان؛ هرکس فقط آنچه را لازم دارد می‌بیند.',
  pl_steps_tag: 'شروع کار',
  pl_steps_title: 'در ۳ مرحله آنلاین شوید',
  pl_step_1_t: 'کسب‌وکارتان را ثبت کنید',
  pl_step_1_d: 'حساب بسازید و زیردامنه‌تان را انتخاب کنید؛ ما همه‌چیز را فوراً آماده می‌کنیم.',
  pl_step_2_t: 'منویتان را بسازید',
  pl_step_2_d: 'دسته‌بندی‌ها، محصولات، عکس‌ها و قیمت‌ها را از پنل مدیریت اضافه کنید. بدون نیاز به دانش فنی.',
  pl_step_3_t: 'آنلاین شوید و سفارش بگیرید',
  pl_step_3_d: 'کد QR یا لینک‌تان را به اشتراک بگذارید؛ مشتری سفارش می‌دهد و شما از داشبورد مدیریت می‌کنید.',
  pl_price_tag: 'تعرفه‌ها',
  pl_price_title: 'قیمت‌گذاری ساده و شفاف',
  pl_price_sub: '۱۴ روز رایگان شروع کنید؛ بدون نیاز به کارت اعتباری.',
  pl_price_basic: 'پایه',
  pl_price_pro: 'حرفه‌ای',
  pl_price_ent: 'سازمانی',
  pl_price_popular: 'محبوب‌ترین',
  pl_price_choose: 'انتخاب پلن',
  pl_price_get_started: 'شروع کنید ←',
  pl_price_mo: '/ماه',
  pl_price_b1: 'یک منوی رستوران',
  pl_price_b2: 'تا ۵۰ محصول',
  pl_price_b3: 'ساخت کد QR',
  pl_price_b4: 'تحلیل‌های پایه',
  pl_price_b5: 'پشتیبانی ایمیلی',
  pl_price_p1: 'منوی نامحدود',
  pl_price_p2: 'محصولات نامحدود',
  pl_price_p3: 'مدیریت لحظه‌ای سفارش',
  pl_price_p4: 'تحلیل‌های پیشرفته',
  pl_price_p5: 'پشتیبانی اولویت‌دار',
  pl_price_p6: 'دامنهٔ اختصاصی',
  pl_price_e1: 'همهٔ امکانات حرفه‌ای',
  pl_price_e2: 'راهکار وایت‌لیبل',
  pl_price_e3: 'دسترسی API',
  pl_price_e4: 'مدیر حساب اختصاصی',
  pl_price_e5: 'تضمین SLA',
  pl_cta_title: 'آماده‌اید دیجیتال شوید؟',
  pl_cta_sub: 'به صدها رستورانی بپیوندید که از نوشین استفاده می‌کنند.',
  pl_cta_btn: 'شروع رایگان',
  pl_foot_tagline: 'پلتفرم همه‌کاره منوی دیجیتال برای رستوران‌ها و کافه‌ها.',
  pl_foot_for_rest: 'برای رستوران‌ها',
  pl_foot_signin: 'ورود',
  pl_foot_admin: 'مدیریت پلتفرم',
};

// ── Restaurant admin panel ────────────────────────────────────────────────────
export const ADMIN_FA = {
  adm_overview: 'نمای کلی',
  adm_products: 'محصولات',
  adm_categories: 'دسته‌بندی‌ها',
  adm_orders: 'سفارش‌ها',
  adm_customers: 'مشتریان',
  adm_admins: 'مدیران',
  adm_settings: 'تنظیمات',
  adm_language: 'زبان',
  adm_admin_lang: 'زبان پنل مدیریت',
  adm_logout: 'خروج',
  adm_ord_title: 'سفارش‌ها',
  adm_ord_refresh: '↻ به‌روزرسانی',
  adm_ord_empty: 'هنوز سفارشی ثبت نشده.',
  adm_ord_customer: 'مشتری',
  adm_ord_phone: 'تلفن',
  adm_ord_address: 'آدرس',
  adm_ord_note: 'یادداشت',
  adm_ord_total: 'جمع کل',
  adm_status_pending: 'در انتظار',
  adm_status_confirmed: 'تأیید شده',
  adm_status_preparing: 'در حال آماده‌سازی',
  adm_status_ready: 'آماده',
  adm_status_delivered: 'تحویل شده',
  adm_status_cancelled: 'لغو شده',
  adm_prod_add: '+ افزودن محصول',
  adm_prod_edit: 'ویرایش',
  adm_prod_delete: 'حذف',
  adm_prod_name: 'نام',
  adm_prod_price: 'قیمت',
  adm_prod_category: 'دسته‌بندی',
  adm_prod_description: 'توضیحات',
  adm_prod_save: 'ذخیره',
  adm_prod_cancel: 'انصراف',
  adm_prod_available: 'موجود',
  adm_prod_unavailable: 'ناموجود کردن',
  adm_cust_title: 'مشتریان',
  adm_cust_edit: 'ویرایش',
  adm_cust_save: 'ذخیره',
  adm_cust_cancel: 'انصراف',
  adm_cust_name: 'نام',
  adm_cust_phone: 'تلفن',
  adm_cust_address: 'آدرس',
  adm_cust_activate: 'فعال‌سازی',
  adm_cust_deactivate: 'غیرفعال‌سازی',
  adm_set_save: 'ذخیره تنظیمات',
  adm_set_name: 'نام رستوران',
  adm_set_address: 'آدرس',
  adm_set_phone: 'تلفن',
  adm_set_hours: 'ساعت کاری',
  adm_set_email: 'ایمیل',
  adm_set_cuisine: 'نوع آشپزی',
  adm_set_tagline: 'شعار',
  adm_set_description: 'توضیحات',
  adm_admin_panel: 'پنل مدیریت',
  adm_restaurant_info: 'اطلاعات رستوران',
  adm_quick_actions: 'دسترسی سریع',
  adm_click_change_files: 'برای تغییر فایل‌ها کلیک کنید',
  adm_click_upload_menu: 'برای بارگذاری عکس منو یا PDF کلیک کنید',
  adm_import_from_files: 'عکس / PDF',
  adm_import_from_url: 'آدرس وب‌سایت',
  adm_import_url_title: 'ورود از یک منوی آنلاین موجود',
  adm_import_url_sub: 'لینک منوی آنلاین فعلی‌تان را وارد کنید — هوش مصنوعی صفحه را اسکن می‌کند و همه آیتم‌ها و دسته‌بندی‌ها را به‌صورت خودکار استخراج می‌کند.',
  adm_import_url_ph: 'https://your-menu-site.com',
  adm_scan_menu_ai: 'اسکن منو با هوش مصنوعی',
  adm_scanning_url: 'در حال اسکن صفحه و استخراج آیتم‌ها — ممکن است ۲۰ تا ۴۰ ثانیه طول بکشد…',
  adm_onb_title: 'شروع کار',
  adm_onb_sub: 'این مراحل را کامل کنید تا منویتان حرفه‌ای راه‌اندازی شود.',
  adm_onb_logo: 'لوگوی خود را اضافه کنید',
  adm_onb_products: 'حداقل ۵ محصول اضافه کنید',
  adm_onb_categories: '۲ دسته‌بندی یا بیشتر بسازید',
  adm_onb_info: 'آدرس و ساعت کاری را تکمیل کنید',
  adm_onb_qr: 'کد QR را دانلود / چاپ کنید',
  adm_onb_done: 'همه‌چیز آماده است — منوی شما فعال شد! 🎉',
  adm_qr_title: 'کد QR منو',
  adm_qr_sub: 'آن را روی میزها و تراکت‌ها چاپ کنید — مشتری اسکن می‌کند و منو فوراً باز می‌شود. بدون نیاز به اپلیکیشن.',
  adm_qr_download: 'دانلود PNG',
  adm_qr_print: 'چاپ کارت رومیزی',
  adm_qr_scan_hint: 'برای مشاهده منو اسکن کنید',
  adm_qr_main: 'منوی اصلی',
  adm_options: 'دکمه‌های ویژگی',
  adm_options_hint: 'دکمه‌های دلخواه این آیتم را اضافه کنید (مثلاً تند 🌶️، گیاهی 🌱).',
  adm_option_label_ph: 'عنوان، مثلاً تند',
  adm_option_icon_ph: 'آیکون',
  adm_add_option: '+ افزودن ویژگی',
  adm_select_all: 'انتخاب همه',
  adm_none: 'هیچ‌کدام',
  adm_item_name: 'نام آیتم',
  adm_price: 'قیمت',
  adm_category: 'دسته‌بندی',
  adm_description: 'توضیحات',
  adm_description_opt: 'توضیحات (اختیاری)',
  adm_bulk_price: 'تغییر قیمت گروهی',
  adm_newest_first: 'جدیدترین',
  adm_oldest_first: 'قدیمی‌ترین',
  adm_highest_value: 'بیشترین مبلغ',
  adm_auto_refresh: 'به‌روزرسانی خودکار',
  adm_no_orders: 'سفارشی یافت نشد.',
  adm_analytics_ai: 'تحلیل و هوش مصنوعی',
  adm_no_customers: 'هنوز مشتری‌ای ندارید.',
  adm_address: 'آدرس',
  adm_cover_image: 'تصویر کاور',
  adm_logo: 'لوگو',
  adm_favicon: 'فاوآیکن (آیکن تب مرورگر)',
  adm_currency: 'واحد پول',
  adm_primary_color: 'رنگ اصلی',
  adm_accent_color: 'رنگ تأکیدی',
  adm_appearance_sub: 'ظاهر منوی مشتریان را انتخاب کنید. تغییرات بعد از ذخیره فوراً اعمال می‌شود.',
  adm_design_template: 'قالب طراحی',
  adm_category_bar: 'نوار دسته‌بندی',
  adm_base_mode: 'حالت پایه',
  adm_colors: 'رنگ‌ها',
  adm_live_preview: 'پیش‌نمایش زنده',
  adm_save_settings: 'ذخیره تنظیمات',
  adm_ai_blog: 'وبلاگ سئوی هوش مصنوعی',
  adm_ai_blog_hint: 'انتشار خودکار یک مقالهٔ چندزبانهٔ روزانه برای رستوران شما جهت بهبود رتبهٔ جستجو (در پلن‌های منتخب)',
  adm_on: 'روشن',
  adm_off: 'خاموش',
  adm_lang_mode: 'حالت زبان',
  adm_default_lang: 'زبان پیش‌فرض',
  adm_enabled_langs: 'زبان‌های فعال',
  adm_translations: 'ترجمه‌ها',
  adm_page_title: 'عنوان صفحه',
  adm_meta_desc: 'توضیحات متا',
  adm_keywords: 'کلمات کلیدی',
  adm_ui_trans_desc: 'دکمه‌ها، برچسب‌ها و پیام‌هایی را که مشتری در سبد خرید، ورود، پروفایل و روند سفارش می‌بیند ترجمه کنید.',
  adm_event_select: 'یک مناسبت را انتخاب کنید تا پاپ‌آپ، تخفیف و بنر هوش مصنوعی برای مشتریان بسازید.',
  adm_live: 'فعال',
  adm_saved: 'ذخیره شد',
  adm_event_config: 'تنظیم پاپ‌آپ، بنر و پیشنهادها برای این مناسبت',
  adm_title_in_popup: 'عنوان نمایشی در پاپ‌آپ',
  adm_message: 'پیام',
  adm_start: 'شروع',
  adm_end: 'پایان',
  adm_popup_daterange: 'پاپ‌آپ فقط در این بازه زمانی به مشتریان نمایش داده می‌شود.',
  adm_type: 'نوع',
  adm_no_discount: 'بدون تخفیف',
  adm_fixed_amount: 'مبلغ ثابت',
  adm_value: 'مقدار',
  adm_promo_code: 'کد تخفیف (اختیاری)',
  adm_featured_badge: 'آیتم‌های انتخابی با نشان ویژه در پاپ‌آپ نمایش داده می‌شوند.',
  adm_paste_image_url: 'یا آدرس تصویر را وارد کنید',
  adm_remove_event: 'حذف مناسبت',
  adm_admin_panel_lang: 'زبان پنل مدیریت',
  adm_admin_lang_desc: 'فقط برچسب‌ها، تب‌ها و دکمه‌های داخل همین داشبورد را ترجمه می‌کند. مشتریان هرگز این متن‌ها را نمی‌بینند.',
  adm_choose_lang: 'انتخاب زبان',
  adm_sub_category: 'زیر‌دسته',
  adm_product_image: 'تصویر محصول',
  adm_tags: 'برچسب‌ها',
  adm_availability: 'وضعیت موجودی',
  adm_cancel: 'انصراف',
  adm_slug_url: 'شناسه (کلید URL)',
  adm_icon: 'آیکون',
  adm_item: 'آیتم',
  adm_qty: 'تعداد',
  adm_thank_you: 'از سفارش شما متشکریم!',
  adm_date: 'تاریخ',
  adm_not_set: 'تنظیم نشده',
  adm_new_subadmin: 'مدیر فرعی جدید',
  adm_access_level: 'سطح دسترسی',
  adm_no_subadmins: 'هنوز مدیر فرعی‌ای ندارید. از بالا اضافه کنید.',
  adm_name: 'نام',
  adm_ph_item_name: 'نام آیتم',
  adm_ph_describe_rest: 'رستوران‌تان را در ۱-۲ جمله توصیف کنید. چه چیزی آن را خاص می‌کند؟',
  adm_keywords_hint: 'با کاما جدا کنید. اهمیت آن از عنوان/توضیحات کمتر است اما برای جستجوهای خاص کمک می‌کند.',
  adm_ph_search_dishes: 'جستجوی غذاها…',
  adm_t_admin_removed: 'مدیر حذف شد',
  adm_t_admin_updated: 'مدیر به‌روزرسانی شد ✓',
  adm_t_availability: 'وضعیت موجودی به‌روزرسانی شد',
  adm_t_banner: 'بنر ساخته و بارگذاری شد ✓',
  adm_t_cat_added: 'دسته‌بندی اضافه شد ✓',
  adm_t_cat_deleted: 'دسته‌بندی حذف شد',
  adm_t_cat_required: 'دسته‌بندی الزامی است',
  adm_t_cat_updated: 'دسته‌بندی به‌روزرسانی شد ✓',
  adm_t_cust_updated: 'مشتری به‌روزرسانی شد ✓',
  adm_t_enable_one_lang: 'ابتدا حداقل یک زبان غیر از زبان پیش‌فرض را فعال کنید',
  adm_t_valid_pct: 'یک درصد معتبر وارد کنید (۱ تا ۱۰۰۰)',
  adm_t_event_removed: 'مناسبت حذف شد',
  adm_t_event_saved: 'مناسبت ذخیره شد ✓',
  adm_t_invalid_json: 'فایل JSON نامعتبر است',
  adm_t_lang_saved: 'تنظیمات زبان ذخیره شد ✓',
  adm_t_name_required: 'نام الزامی است',
  adm_t_order_updated: 'سفارش به‌روزرسانی شد',
  adm_t_prod_added: 'محصول اضافه شد ✓',
  adm_t_prod_deleted: 'محصول حذف شد',
  adm_t_prod_updated: 'محصول به‌روزرسانی شد ✓',
  adm_t_reset_defaults: 'به پیش‌فرض انگلیسی بازنشانی شد ✓',
  adm_t_reset_en: 'به انگلیسی بازنشانی شد ✓',
  adm_t_select_item: 'حداقل یک آیتم را برای ورود انتخاب کنید',
  adm_t_settings_saved: 'تنظیمات ذخیره شد ✓',
  adm_t_subadmin_created: 'مدیر فرعی ساخته شد ✓',
  adm_t_switch_multi: 'ابتدا به حالت چندزبانه بروید و چند زبان را فعال کنید',
  adm_t_trans_cleared: 'ترجمه‌ها پاک شد',
  adm_t_trans_imported: 'ترجمه‌ها وارد شد ✓ — یادتان باشد ذخیره کنید',
  adm_t_valid_price: 'قیمت معتبر الزامی است',
  adm_t_done_errors: 'انجام شد، با خطا در:',
  adm_t_imported: 'محصول با موفقیت وارد شد!',
  adm_t_translated_into: 'محتوا و متن‌های رابط کاربری ترجمه شد ✓',
  adm_t_translated_saved: 'ترجمه و ذخیره شد ✓',
  adm_t_translated_ui: 'متن‌های رابط کاربری ترجمه شد ✓',
  adm_t_admin_translated: 'پنل مدیریت ترجمه شد ✓',
  adm_t_prices_adjusted: 'همه قیمت‌ها تغییر کرد ✓',
  adm_c_remove_event: 'این رویداد حذف شود؟',
  adm_c_delete_product: 'این محصول حذف شود؟ این عمل قابل بازگشت نیست.',
  adm_c_delete_category: 'این دسته‌بندی و همهٔ محصولات آن حذف شوند؟ این عمل قابل بازگشت نیست.',
  adm_c_remove_admin: 'این حساب مدیر حذف شود؟ این عمل قابل بازگشت نیست.',
  adm_c_clear_admin_trans: 'همهٔ ترجمه‌های پنل مدیریت پاک شوند؟',
  adm_c_bulk_price: 'قیمت همهٔ محصولات با این درصد تغییر کند؟ بلافاصله ذخیره می‌شود.',
  adm_c_server_translate: 'کل منو روی سرور به همهٔ زبان‌های فعال ترجمه و ذخیره شود؟ ترجمه‌های موجود حفظ می‌شوند — فقط موارد خالی پر می‌شوند.',
  adm_ph_describe_dish: 'غذا را توصیف کنید…',
  adm_ph_cat_desc: 'توضیح کوتاه برای این دسته‌بندی',
  adm_t_auto_translate: 'ترجمهٔ خودکار',
  adm_t_translating: 'در حال ترجمه…',
  adm_t_translating_all: 'در حال ترجمهٔ همه…',
  adm_t_translate_all_save: 'ترجمهٔ همهٔ زبان‌ها و ذخیره',
  adm_t_auto_title: 'ترجمهٔ همه‌چیز به این زبان (در همین مرورگر اجرا می‌شود)',
  adm_t_all_title: 'ترجمهٔ کل منو به همهٔ زبان‌های فعال روی سرور و ذخیره — حتی اگر این صفحه را ببندید ادامه می‌یابد',
  adm_t_method_note: 'ترجمهٔ خودکار زبان انتخاب‌شده را در مرورگر شما پر می‌کند. «ترجمهٔ همهٔ زبان‌ها و ذخیره» کاملاً روی سرور اجرا می‌شود — همهٔ زبان‌های فعال را یک‌جا ترجمه می‌کند، ترجمه‌های موجود را نگه می‌دارد و بلافاصله ذخیره می‌کند (می‌توانید این صفحه را ببندید). ترجمه از مدل هوش مصنوعی به‌همراه ارائه‌دهندگان رایگان (MyMemory → Lingva → LibreTranslate) استفاده می‌کند؛ پیش از انتشار نتایج را بازبینی کنید — ترجمهٔ ماشینی ممکن است بی‌نقص نباشد.',
  adm_branch_editing: 'در حال ویرایش منوی:',
  adm_branch_main: 'رستوران اصلی',
  adm_branch_note: 'محصولات و دسته‌بندی‌های زیر متعلق است به',
  adm_branch_sync: 'یکسان‌سازی همهٔ شعبه‌ها',
  adm_view_menu: 'مشاهدهٔ منو',
  adm_logout: 'خروج',
  adm_sync_differ: 'شعبه‌های شما در حال حاضر منوهای متفاوتی دارند. انتخاب کنید چگونه یکسان شوند:',
  adm_sync_same: 'همهٔ شعبه‌ها همین حالا منوی یکسانی دارند. می‌توانید یک منبع را دوباره اعمال کنید.',
  adm_sync_merge: 'ادغام همه — حفظ همهٔ موارد',
  adm_sync_merge_desc: 'موارد همهٔ شعبه‌ها را در یک منوی مشترک ترکیب می‌کند، سپس روی همهٔ شعبه‌ها و رستوران اصلی اعمال می‌شود.',
  adm_sync_copy: 'کپی یک منو روی همهٔ شعبه‌ها',
  adm_sync_copy_desc: 'یک منبع را انتخاب کنید؛ همهٔ شعبه‌ها دقیقاً مطابق آن بازنویسی می‌شوند.',
  adm_sync_source: 'منوی منبع',
  adm_sync_apply: 'اعمال روی همهٔ شعبه‌ها',
  adm_sync_working: 'در حال یکسان‌سازی…',
  adm_sync_done: 'همهٔ شعبه‌ها اکنون یکسان هستند ✓',
  adm_agg_toggle: 'منوی ترکیبی',
  adm_agg_hint: 'وقتی روشن است، دامنهٔ اصلی یک منو با همهٔ غذاهای همهٔ شعبه‌ها نمایش می‌دهد (بدون تکرار، با برچسب روی مواردی که در همهٔ شعبه‌ها نیستند). خاموش = بازدیدکننده باید یک شعبه انتخاب کند.',
  adm_agg_saved: 'تنظیم منوی ترکیبی ذخیره شد ✓',
  adm_branch_orders: 'سفارش‌های:',
  adm_branch_all_orders: 'همهٔ شعبه‌ها',
  adm_subadmin_branches: 'دسترسی شعبه',
  adm_subadmin_branches_hint: 'برای دسترسی کامل به همهٔ شعبه‌ها هیچ‌کدام را تیک نزنید. برای محدود کردن این مدیر، شعبه‌های خاص را تیک بزنید.',
};

/** Languages written right-to-left across the whole system. */
export const RTL_LANGS = ['fa', 'ar', 'he'];
